import { render, staticRenderFns } from "./ReplaceAndDisableUser.vue?vue&type=template&id=2d1a116c&scoped=true&"
import script from "./ReplaceAndDisableUser.vue?vue&type=script&lang=js&"
export * from "./ReplaceAndDisableUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1a116c",
  null
  
)

export default component.exports